import { all, fork } from "redux-saga/effects";
import {
  watchRmBuddiesSearchQuery,
  watchRmBuddiesBuddyBlockId
} from "./fulltext-search";

import {
  watchUploadRmBuddies,
  watchRmBuddiesServerSearch,
  watchViewAssignedBuddy,
  watchAssignBuddy,
  watchRmBuddiesWarehouseId,
  watchEditProfileSelectedRmBuddy,
  watchFetchLeavesAction,
  watchApplyLeavesAction,
  watchRemoveLeavesAction
} from "./rm-buddies";

import { watchFetchWarehouse } from "./warehouse";
import {
  watchWarehouseIdChange,
  watchDueDateChange,
  watchTaskSelected,
  watchMarkAsDoneSelected,
  watchFetchSuggestedBuddiesAction,
  watchTransferTaskAction,
  watchSelectedBuddyIdChange,
  watchSearchAction,
  watchFetchPendingTasksOfSelectedBuddy,
  watchTransferValidationAction
} from "./rm-buddy-tasks";

export default function* rootSaga() {
  yield all([
    fork(watchRmBuddiesSearchQuery),
    fork(watchRmBuddiesBuddyBlockId),
    fork(watchUploadRmBuddies),
    fork(watchRmBuddiesServerSearch),
    fork(watchViewAssignedBuddy),
    fork(watchAssignBuddy),
    fork(watchRmBuddiesWarehouseId),
    fork(watchFetchWarehouse),
    fork(watchWarehouseIdChange),
    fork(watchDueDateChange),
    fork(watchTaskSelected),
    fork(watchMarkAsDoneSelected),
    fork(watchFetchSuggestedBuddiesAction),
    fork(watchTransferTaskAction),
    fork(watchSelectedBuddyIdChange),
    fork(watchSearchAction),
    fork(watchEditProfileSelectedRmBuddy),
    fork(watchFetchLeavesAction),
    fork(watchApplyLeavesAction),
    fork(watchFetchPendingTasksOfSelectedBuddy),
    fork(watchRemoveLeavesAction),
    fork(watchTransferValidationAction)
  ]);
}
